import AppProvider from './src/providers/AppProvider';

export const wrapRootElement = AppProvider;
